import { MC } from '../utils/constants.js';

export function Footer({ isFloatpanel }) {
  const footerHtml = MC.BRAND.includes('MageComp')
    ? MC.BRAND.replace('MageComp', `<a href="${MC.BRAND_URL}" target="_blank" rel="noopener noreferrer">MageComp</a>`)
    : `${MC.BRAND} <a href="${MC.BRAND_URL}" target="_blank" rel="noopener noreferrer">MageComp</a>`;

  return (
    <footer
      class={isFloatpanel ? 'mc-gfooter' : 'mc-footer'}
      aria-label="Branding"
      dangerouslySetInnerHTML={{ __html: footerHtml }}
    />
  );
}
